@if (!masque) {
	@if (loading) {
		<button disabled class="{{ classLoading }}">
			<div class="spinner-border" role="status"></div>
		</button>
	} @else {
		<button [title]="title" type="button" (click)="clickBtn.emit()" [hidden]="hidden" class="{{ class }} btn  " [disabled]="disabled">
			{{ label }}
		</button>
	}
}
